<lcs-advanced-multi-select
  [headerText]="extensionAndGroupEntityName"
  class="reports-multi-select"
  [triggerConfig]="triggerConfig()"
  [datasources]="datasources()"
  [hasRestoreDefaults]="false"
  (init)="onInit($event)"
  (save)="onSave($event)"
  (search)="onSearch($event)"
  (openDialog)="onOpen($event)"
  (selectedItemsChange)="onSelectedItemsChange($event)"
  (close)="onClose($event)"
  (allChange)="onAllChange($event)"
  >
  <ng-template let-context advancedMultiSelectItemRowDisplay>
    <lcs-advanced-multi-select-item [context]="context" [item]="context.item" [selected]="context.selected">
      <div class="item-label">
        @if (context.position === 'right') {
          <mat-icon>
            {{ context.item.type === 'extension' ? 'phone' : 'group' }}
          </mat-icon>
        }
        {{ aggregateDisplayWithFn(context.item) }}
      </div>
    </lcs-advanced-multi-select-item>
  </ng-template>
</lcs-advanced-multi-select>
